export default __webpack_public_path__ + "static/media/NewTown_sm.e290a844.jpg";